
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1t3Es", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=pt-BR.c60aea02.js.map
